import {useEffect, useState} from 'react';

import {isString} from 'ramda-adjunct';

import {TestIdProps} from 'shared/web';

import {SMART_SEARCH_KEY} from '../constants/smartSearchKey';
import {useDataGridFiltersModel} from '../context/useDataGridFiltersModel';
import {GridApi} from '../types/AgGridTypes';
import {DataGridProps} from '../types/DataGridProps';
import {QuickFilterRenderer} from './QuickFilterRenderer';

export interface QuickFilterWrapperProps extends TestIdProps {
  gridProps: DataGridProps;
  gridApi?: GridApi;
}

const getSmartSearchValue = (filterValue: unknown): string => {
  if (isString(filterValue)) {
    return filterValue;
  }
  return '';
};

export const QuickFilterWrapper = (props: QuickFilterWrapperProps) => {
  const {filterValues} = useDataGridFiltersModel();
  const {gridProps, gridApi} = props;

  const smartSearchFilterValue = filterValues[SMART_SEARCH_KEY];

  const [quickFilterValue, setQuickFilterValue] = useState<string>(() =>
    getSmartSearchValue(smartSearchFilterValue)
  );

  useEffect(() => {
    setQuickFilterValue(getSmartSearchValue(smartSearchFilterValue));
  }, [smartSearchFilterValue]);
  const submitQuickFilter = (quickFilter?: string) => {
    if (!gridApi) {
      return;
    }

    const filters = gridApi.getFilterModel();
    gridApi.setFilterModel({...filters, [SMART_SEARCH_KEY]: quickFilter});
    gridApi.onFilterChanged('api');
  };

  return (
    <QuickFilterRenderer
      submitQuickFilter={submitQuickFilter}
      cancelQuickFilter={submitQuickFilter}
      quickFilterValue={quickFilterValue}
      onQuickFilterValueChange={setQuickFilterValue}
      gridCode={gridProps.gridCode as string}
      data-testid={props['data-testid']}
      gridApi={gridApi}
    />
  );
};
